import { makeAutoObservable } from 'mobx';
import { TUserPanelNavItemType } from '@features/userPanel/typescript';
import UserPanelAddressesStore from '@features/userPanel/mobx/stores/UserPanelAddressesStore';
import UserPanelOrdersStore from '@features/userPanel/mobx/stores/UserPanelOrdersStore';
import { CustomerDataStore, store as customerDataStoreRef } from '@features/customerData/mobx/context/CustomerDataStoreProvider';
import { NAVIGATION_ITEM_ADDRESS, NAVIGATION_ITEM_BILLINGS, NAVIGATION_ITEM_CREATIVE, NAVIGATION_ITEM_MY_ACCOUNT, NAVIGATION_ITEM_ORDERS } from '@features/userPanel/const';
import UserPanelCreativeStore from '@features/userPanel/mobx/stores/UserPanelCreativeStore';
class UserPanelStore {
  selectedNavItem: TUserPanelNavItemType | null = null;
  addressesState: UserPanelAddressesStore = {} as UserPanelAddressesStore;
  userOrdersState: UserPanelOrdersStore = {} as UserPanelOrdersStore;
  userCreativeState: UserPanelCreativeStore = {} as UserPanelCreativeStore;
  customerDataStoreRef: CustomerDataStore = customerDataStoreRef;
  constructor() {
    makeAutoObservable(this);
  }
  createUserPanelOrdersStore = (customerId: string) => {
    this.userOrdersState = new UserPanelOrdersStore(customerId);
  };
  createUserPanelCreativeStore = (customerId: string) => {
    this.userCreativeState = new UserPanelCreativeStore(customerId);
  };
  createUserPanelAddressesStore = () => {
    this.addressesState = new UserPanelAddressesStore();
  };
  setUserPanelItem = (item: TUserPanelNavItemType | null) => {
    this.selectedNavItem = item;
    if ((item?.name === NAVIGATION_ITEM_MY_ACCOUNT.name || item?.name === NAVIGATION_ITEM_ORDERS.name) && this.customerDataStoreRef.id) {
      this.createUserPanelOrdersStore(this.customerDataStoreRef.id);
    }
    if (item?.name === NAVIGATION_ITEM_CREATIVE.name || item?.name === NAVIGATION_ITEM_CREATIVE.name) {
      this.createUserPanelCreativeStore(this.customerDataStoreRef.id);
    }
    if (item?.name === NAVIGATION_ITEM_ADDRESS.name || item?.name === NAVIGATION_ITEM_BILLINGS.name) {
      this.createUserPanelAddressesStore();
    }
  };
}
export default UserPanelStore;